import ff from './ff';

export default class c20d {

static d_defs = {

/*
  DROP TABLE t_c20r;
  CREATE TABLE t_c20r (_key SERIAL PRIMARY KEY, _vsn INTEGER, _ltt INTEGER, _fst INTEGER, 
    c20rc11s TEXT,
    c20rc31s TEXT,
    c20rc32s TEXT,
    c20rc33s TEXT,
    c20ri11s TEXT,
    c20ri12s TEXT,
    c20ri21s TEXT,
    c20ri22s TEXT,
    c20rcx1i INTEGER,
    c20rcy1t TEXT,
    c20rcy1f INTEGER,
    c20rcz1i INTEGER
  );
  INSERT INTO t_c20r (_key, _fst, _vsn, _ltt, c20rc11s, c20rc31s, c20ri11s, c20ri12s, c20rcx1i, c20rcy1t, c20rcy1f, c20rcz1i)
  VALUES (0, 0, 1, 1, '0', '全体共通', '', '', 9999, '2000-01-01 00:00:00', 1, 10);

  INSERT INTO t_c20r (_vsn, _ltt, c20rc11s, c20rc31s, c20ri11s, c20ri12s, c20rcx1i, c20rcy1t, c20rcy1f, c20rcz1i)
  VALUES (1, 1, '1', '青葉台地域ケアプラザ', 'c-aobadai-staff', 'c-aobadai', 9999, '2000-01-01 00:00:00', 1, 10);

  UPDATE t_c20r SET _fst = _key;

*/

  c20r: {
    0: {
      pfx: '利用会社基礎情報',
      dd_fldDefss: {
        c20rc11s: { // cm21 の最新情報を反映
          pfx: 'ID',
          type: 'Inp',
          n_col: 4,
        },
        c20rc31s: { // cm21 の最新情報を反映
          pfx: '表記',
          type: 'Inp',
          n_col: 15,
        },
        c20rc32s: {
          pfx: '正式名',
          type: 'Inp',
        },
        c20rc33s: {
          pfx: 'よみがな',
          type: 'Inp',
        },
        c20ri11s: {
          pfx: 'スタッフ用サブドメイン',
          type: 'Inp',
          n_col: 15,
        },
        c20ri12s: {
          pfx: '団体用サブドメイン',
          type: 'Inp',
          n_col: 15,
        },
        c20ri21s: {
          pfx: '管理者用ログインID',
          type: 'Inp',
          n_col: 15,
        },
        c20ri22s: {
          pfx: '管理者用パスワード',
          type: 'Inp',
          n_col: 15,
        },
        c20ri31s: {
          pfx: '決済用公開鍵',
          type: 'Inp',
          n_col: 15,
        },
        c20ri32s: {
          pfx: '決済用秘密鍵',
          type: 'Inp',
          n_col: 15,
        },
      },
    },
  },

};

};
/*
 Copyright 2020 Yukio Shinohara All rights reserved.
 */
